import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import ApprovalHistoryComponent from './ApprovalHistoryComponent';
import { Dialog, Button } from '@totalsoft/rocket-ui';
import WrappedFakeText from 'components/common/WrappedFakeText';
import { BoxActionsWrapper } from 'components/common/CommonStyles';

const ApprovalsHistoryModal = ({ t, showModal, approvalsHistoryLoading, approvalsHistory, onCloseModal }) => {
  return (
    <Dialog
      open={showModal}
      onClose={onCloseModal}
      aria-labelledby='approvalsHistory-dialog-title'
      maxWidth='lg'
      title={t('Document.Decision.ApprovalLevels.ApprovalsHistory.Title')}
      content={
        !approvalsHistory || approvalsHistoryLoading ? (
          <WrappedFakeText lines={5} />
        ) : (
          <Grid container>
            <Grid item xs={12}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align={'right'}>
                      <strong>{t('Document.Decision.ApprovalLevels.ApprovalsHistory.DocumentNumber')}</strong>
                    </TableCell>
                    <TableCell align={'right'}>
                      <strong>{t('Document.Decision.ApprovalLevels.ApprovalsHistory.DecisionType')}</strong>
                    </TableCell>
                    <TableCell align={'right'}>
                      <strong>{t('Document.Decision.ApprovalLevels.ApprovalsHistory.ApprovalLevel')}</strong>
                    </TableCell>
                    <TableCell align={'right'}>
                      <strong>{t('Document.Decision.ApprovalLevels.ApprovalsHistory.FileDecision')}</strong>
                    </TableCell>
                    <TableCell align={'right'}>
                      <strong>{t('Document.Decision.ApprovalLevels.ApprovalsHistory.Comments')}</strong>
                    </TableCell>
                    <TableCell align={'right'}>
                      <strong>{t('Document.Decision.ApprovalLevels.ApprovalsHistory.User')}</strong>
                    </TableCell>
                    <TableCell align={'right'}>
                      <strong>{t('Document.Decision.ApprovalLevels.ApprovalsHistory.Date')}</strong>
                    </TableCell>
                    <TableCell align={'right'}>
                      <strong>{t('Document.Decision.ApprovalLevels.ApprovalsHistory.ApprovedBy')}</strong>
                    </TableCell>
                    <TableCell align={'right'}>
                      <strong>{t('Document.Decision.ApprovalLevels.ApprovalsHistory.HistoryTimestamp')}</strong>
                    </TableCell>
                    <TableCell>
                      <strong>{t('Document.Decision.ApprovalLevels.AdvancePercent')}</strong>
                    </TableCell>
                    <TableCell>
                      <strong>{t('Document.Decision.ApprovalLevels.Period')}</strong>
                    </TableCell>
                    <TableCell>
                      <strong>{t('Document.Decision.ApprovalLevels.ResidualValuePercent')}</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {approvalsHistory.map((approval, index) => {
                    return <ApprovalHistoryComponent key={index} approval={approval} />;
                  })}
                </TableBody>
              </Table>
            </Grid>
          </Grid>
        )
      }
      actions={
        <BoxActionsWrapper forDialog>
          <Button onClick={onCloseModal} color='primary'>
            {t('Close')}
          </Button>
        </BoxActionsWrapper>
      }
    />
  );
};

ApprovalsHistoryModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  approvalsHistoryLoading: PropTypes.bool,
  t: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  approvalsHistory: PropTypes.array.isRequired
};

export default withTranslation()(ApprovalsHistoryModal);
